<p-calendar
  [(ngModel)]="value"
  [showIcon]="true"
  dateFormat="dd/mm/yy"
  [disabled]="disabled"
  [showButtonBar]="true"
></p-calendar>
<rb-error-marker [control]="ngControl.control"></rb-error-marker>
